/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./KeyValueField.vue?vue&type=template&id=ef12dfaa&scoped=true"
import script from "./KeyValueField.vue?vue&type=script&lang=js"
export * from "./KeyValueField.vue?vue&type=script&lang=js"
import style0 from "./KeyValueField.vue?vue&type=style&index=0&id=ef12dfaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef12dfaa",
  null
  
)

export default component.exports